import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const CaptionWrapper = styled.div`
  display: flex;
  gap: 10px;
  div {
    display: flex;
    &:first-child {
      flex: 2;
    }
  }
`;

export const ReconfigureSection = styled.div`
  display: flex;
  height: 34px;
  width: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 6px;
  cursor: pointer;
`;
